import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';

import { DATE_FORMAT_MMMM_YYYY } from 'constants/formats';
import dayjs from 'dayjs';

import { DatePickerControl } from 'components/_basic/Form/DatePicker';

import { IMonthYearDatePickerProps } from './types';

import scssVariables from 'styles/sass-variables.module.scss';

export const MonthYearDatepicker: FC<IMonthYearDatePickerProps> = memo(({ name, disabled }) => {
  const { control } = useFormContext();

  return (
    <DatePickerControl
      views={['year', 'month']}
      dateFormat={DATE_FORMAT_MMMM_YYYY}
      defaultValue={dayjs()}
      control={control}
      id={name}
      name={name}
      disabled={disabled}
      sx={{
        maxWidth: '180px',
        svg: {
          width: '16px',
          height: '16px',
          '& path': {
            fill: scssVariables.primary_purple_default,
          },
        },
        '.MuiInputBase-root': {
          background: scssVariables.greys_background,
          borderRadius: '100px',
          color: scssVariables.primary_purple_default,
          '& > .MuiOutlinedInput-input': {
            padding: '4px 0 4px 12px',
            fontSize: '12px',
            '&::placeholder': {
              fontSize: 'inherit',
            },
          },
          '& > .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiButtonBase-root': {
            color: scssVariables.primary_purple_default,
          },
          '.MuiButtonBase-root': {
            margin: 0,
          },
        },
      }}
    />
  );
});
